import {
    createColumnBoolean,
    createColumnDate,
    createColumnInput,
    createColumnSelect
} from "../../../../components/table/c-table.logic";
import i18n from "../../../../i18n";
import { putField } from "../../../../utils/form";
import { callDocumentStatus } from "../../storage-location/storage-location/storage-location.section";
import { callHazObject, callHazType } from "../request/haz-info/haz-info.section";
import { callUserObjective } from "../request/request.section";
import moment from "moment";

export const createColumns = () => {
    const columns = [
        createColumnInput({
            title: () => i18n.global.t("model.haz.refUserCompany"),
            dataIndex: "refUserCompany.companyNameTh",
            dataIndexValue: ({ record }) =>
                record.refUserCompany?.refPersonType?.key === "1" ? record.refUserCompany?.companyNameTh : record.refUserCompany?.fullNameTh,
            customRender: ({ record, column }) => column.dataIndexValue({ record })
        }),
        createColumnInput({ title: () => i18n.global.t("model.haz.approveCode2"), dataIndex: "approveCode2", align: "center" }),
        createColumnInput({ title: () => i18n.global.t("model.haz.approveCode"), dataIndex: "approveCode", align: "center" }),
        createColumnDate({ title: () => i18n.global.t("model.haz.effectiveDate"), dataIndex: "effectiveDate", align: "center" }),
        createColumnDate({ title: () => i18n.global.t("model.haz.expireDate"), dataIndex: "expireDate", align: "center" }),
        createColumnSelect({
            title: () => i18n.global.t("model.haz.refType"),
            dataIndex: "refType.value",
            inputProp: () => ({ list: callHazType, optLabel: "value" }),
            search: { name: "refType.id" }
        }),
        createColumnSelect({
            title: () => i18n.global.t("model.haz.refHazObject"),
            dataIndex: "refHazObject.nameTh",
            inputProp: () => ({ list: callHazObject, optLabel: "nameTh" }),
            search: { name: "refHazObject.id" }
        }),
        createColumnInput({
            title: () => i18n.global.t("model.haz.tradeNameTh").replace(" (TH)", ""),
            dataIndex: "tradeNameTh",
            align: "center"
        }),
        createColumnSelect({
            title: () => i18n.global.t("model.haz.refOperation"),
            dataIndex: "refOperation.value",
            inputProp: () => ({ list: callUserObjective, optLabel: "value" }),
            search: { name: "refOperation.id" }
        }),
        createColumnSelect({
            title: () => i18n.global.t("model.haz.refStatus"),
            dataIndex: "refStatus.value",
            customRender: ({ record }) => {
                let text = record.refStatus?.value;
                if (record.expireDate && moment().diff(record.expireDate, 'days') >= 0) {
                    text += " (หมดอายุ)";
                }
                return <div>{text}</div>
            },
            inputProp: () => ({ list: callDocumentStatus, optLabel: "value" }),
            search: { name: "refStatus.id" },
            align: "center"
        }),
        createColumnBoolean({
            visible: () => false,
            title: () => i18n.global.t("views.request.isExpire"),
            search: {
                name: "expireDate",
                type: "Date",
                getOperator: ({ value }) => value?.key === "true" ? "<=" : ">",
                getValue: () => moment().format("YYYY-MM-DD")
            },
            align: "center",
        }),
    ];
    return columns;
};

export const createField = ({ data }) => {
    return putField({
        data,
        fields: []
    });
};
